import { APIMethod, fetchData } from "@client";

export async function createWorkspaceQuery({ name }) {
  const res = await fetchData("/workspace", APIMethod.PUT, {
    data: { name, type: "free" },
  });

  return res.results;
}
